import { Space } from 'antd';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import classNames from './StandardVehiclePanel.module.scss';

const StandardVehiclePanel = ({ t, productDetails }) => {
  const standardVehicle = productDetails?.standardVehicle;
  const { year, make, model } = standardVehicle || {};

  const hasVehicleData = year || make || model;

  return (
    <div className={classNames.standardVehiclePanel}>
      <Space direction="vertical" size="small" className={classNames.content}>
        <div className={classNames.title}>
          <strong>{t('standardVehicle')}</strong>
        </div>

        {hasVehicleData ? (
          <div>{[year, capitalize(make), capitalize(model)].filter(Boolean).join(' ')}</div>
        ) : (
          <div className={classNames.noData}>{t('noVehicleDataAvailable')}</div>
        )}
      </Space>
    </div>
  );
};

StandardVehiclePanel.propTypes = {
  t: PropTypes.func.isRequired,
  productDetails: PropTypes.shape({
    standardVehicle: PropTypes.shape({
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      make: PropTypes.string,
      model: PropTypes.string,
    }),
  }),
};

StandardVehiclePanel.defaultProps = {
  productDetails: null,
};

export default StandardVehiclePanel;
